import store from "@/store/index";
import { useRouter } from "vue-router";

const router = useRouter();

const checkAccess = () => {
  return store.state.loggedIn;
};

const hasCommons = (user) => {
  if (!user || !user.areaMuni) return false;

  const noCommonsList = ["PRENSA", "INSPECTORES", "MULTAS"];

  // Filtramos las áreas del usuario que NO están en la lista de noCommons
  const areasDiferentes = user.areaMuni.filter(
    (area) => !noCommonsList.includes(area.area.area_name)
  );

  // Si hay al menos una área diferente, retorna true, sino false
  return areasDiferentes.length > 0;
};

const pushToMuni = () => {
  const user = store.state.user;
  const commons = hasCommons(user);

  user.muniAreas.forEach((item) => {
    if (item.area.area_name === "PRENSA" && !commons) {
      router.push({ name: "noticias" });
      return;
    }
    if (item.area.area_name === "MULTAS" && !commons) {
      router.push({ name: "multas" });
      return;
    }
    if (item.area.area_name === "INSPECTORES" && !commons) {
      router.push({ name: "inspectores" });
      return;
    }
  });

  if (commons) {
    router.push({ name: "muni-agentes" });
    return;
  }
};

class Validator {
  static async pushTo() {
    if (!checkAccess()) {
      router.push({ name: "login" });
      return;
    }

    if (store.state.user.role) pushToMuni();

    return;
  }
}

export default Validator;
